<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">
                  <span data-tour-step="1">Halo {{memberSessionArr.name}}!</span>
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Beranda</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <router-link :to="'/order/active_voucher'">
                <div class="card dash-widget" data-tour-step="2">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i class="fa fa-shopping-cart"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3>{{numActiveVoucherTotal}}</h3>
                      <span>Aktif Voucher</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <a href="javascript:void(0)" @click.prevent="redirectToLicenseByClick">
                <div class="card dash-widget" data-tour-step="3">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i class="fa fa-whatsapp"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3>{{numLicenseTotal}}</h3>
                      <span>Akun Whatsapp</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <!-- <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <router-link :to="'/agent/list'">
                <div class="card dash-widget" data-tour-step="4">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i class="fa fa-user"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3>{{numAgentTotal}}</h3>
                      <span>Agents</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>-->
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <router-link :to="'/message_report/outbox'">
                <div class="card dash-widget" data-tour-step="5">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i class="fa fa-envelope"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3>{{nFormatter(numMessageTotal)}}</h3>
                      <span>Pesan Terkirim</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3"></div>
          </div>

          <!-- Statistics Widget -->
          <graph-sum-license data-tour-step="6" />
          <almost-expired />
          <!--  
          <introduction />-->

          <!-- /Statistics Widget -->
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
    <v-tour name="tourGuide" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>
<script>
import Introduction from "./components/Introduction.vue";
import AlmostExpired from "./components/AlmostExpired.vue";
import GraphSumLicense from "./components/graphSumLicense.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { nFormatter } from "@/utils/helper";
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    GraphSumLicense,
    AlmostExpired,
    Introduction
  },
  data() {
    return {
      tourId: "dashboard.admin",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Kamu bisa melihat statistik dan notifikasi lisensi di halaman Beranda.`
        },
        {
          target: '[data-tour-step="2"]',
          content:
            "Informasi jumlah <b>Voucher Aktif</b> yang dapat digunakan untuk membuat akun Whatsapp baru atau memperpanjang masa aktif akun lama."
        },
        {
          target: '[data-tour-step="3"]',
          content: "Jumlah akun Whatsapp yang dibuat."
        },
        {
          target: '[data-tour-step="4"]',
          content: "Jumlah Agent untuk mengelola akun dan chat via Waajo."
        },
        {
          target: '[data-tour-step="5"]',
          content:
            "Total pesan terkirim dari semua lisensi sejak awal digunakan."
        },
        {
          target: '[data-tour-step="6"]',
          content: "Statistik pesan dalam waktu 6 bulan terakhir."
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    }
  },
  created() {
    this.getLicenseTotal();
    this.getAgentTotal();
    this.getMessageTotal();
    this.$store.dispatch("member/getActiveVoucherTotal");
    // this.tourDetail();
  },
  methods: {
    redirectToLicenseByClick() {
      this.fieldsGetLicenseList.license_status = "";
      this.$router.push({ path: "/member/active-lisence" });
    },
    tourShow() {
      this.$tours["tourGuide"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal() {
      let params = {};
      params = {
        provider: "whatsapp"
      };
      this.$store.dispatch("member/getMessageTotal", params);
    },
    getLicenseTotal() {
      this.$store.dispatch("member/getLicenseTotal");
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    }
  },
  name: "index"
};
</Script>


// WEBPACK FOOTER //
// src/views/dashboard/index.vue